import { Button } from '@mui/material';
import ModalV2 from '/@/components/bayer/modal-v2';
import { _ } from '/@/locale';
import YieldEstimationGuide from '/@/views/fields/field-monitoring/components/yield-estimation-guide';

/** "Guía rápida para tomar muestras" — the quick sampling-guide modal. */
const YieldEstimationGuideModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
    return (
        <ModalV2
            open={open}
            onClose={onClose}
            actions={
                <Button color='secondary' onClick={onClose}>
                    {_('Entendido')}
                </Button>
            }
            title={_('Guía rápida para tomar muestras')}
            actionsProps={{ sx: { justifyContent: 'end' } }}
            maxWidth={'md'}
        >
            <YieldEstimationGuide />
        </ModalV2>
    );
};

export default YieldEstimationGuideModal;
